import React from 'react';

// Shown on the Dancers, Entry library and Staff & Chaperones pages while the
// school's School Registration Fee hasn't been received (locks.paymentPending
// from /api/teacher/school-locks). Teachers can keep adding — this just lets
// them know OSSDF won't treat those registrations as confirmed until then.
// Styled as a boxed warning (Badge "warning" colours) so it can't be missed.
// what: e.g. 'dancers', 'entries', 'teachers and chaperones'.
export default function PaymentPendingNote({ locks, what }) {
  if (!locks?.paymentPending) return null;
  return (
    <div
      role="alert"
      style={{
        display: 'flex', alignItems: 'flex-start', gap: 12,
        background: '#FAEEDA', border: '1px solid #E8C78F', borderLeft: '5px solid #D98E1F',
        borderRadius: 8, padding: '12px 16px', marginBottom: 20,
      }}
    >
      <span aria-hidden="true" style={{ fontSize: 22, lineHeight: 1, color: '#D98E1F' }}>⚠</span>
      <div>
        <div style={{ fontSize: 15, fontWeight: 600, color: '#854F0B', marginBottom: 2 }}>
          Pending event payment
        </div>
        <div style={{ fontSize: 14, color: '#5C3A08' }}>
          Your school's event registration fee hasn't been received yet. You can keep adding {what}, but
          all of your registrations (participants, entries and teachers) are <strong>pending</strong> until it's paid.
        </div>
      </div>
    </div>
  );
}
